import { cn } from '@/shared/lib/cn';

/**
 * Photo frame overlay: a rounded rectangle outline visible only at the four
 * corners. Marks a tile as a photo without tinting the image.
 *
 * Geometry is shared with Apple and Android: inset 6, corner radius 6,
 * arm length 14, stroke 1.5, white at 85% alpha.
 */
export function PhotoFrameCorners({ className }: { className?: string }) {
  const corner =
    'pointer-events-none absolute h-[20px] w-[20px] border-white/85';

  return (
    <div
      aria-hidden
      className={cn('pointer-events-none absolute inset-[6px]', className)}
      style={{ borderWidth: 0 }}
    >
      <span
        className={cn(corner, 'start-0 top-0 rounded-ss-[6px]')}
        style={{ borderTopWidth: 1.5, borderInlineStartWidth: 1.5 }}
      />
      <span
        className={cn(corner, 'end-0 top-0 rounded-se-[6px]')}
        style={{ borderTopWidth: 1.5, borderInlineEndWidth: 1.5 }}
      />
      <span
        className={cn(corner, 'end-0 bottom-0 rounded-ee-[6px]')}
        style={{ borderBottomWidth: 1.5, borderInlineEndWidth: 1.5 }}
      />
      <span
        className={cn(corner, 'start-0 bottom-0 rounded-es-[6px]')}
        style={{ borderBottomWidth: 1.5, borderInlineStartWidth: 1.5 }}
      />
    </div>
  );
}
